<template>
  <app-page-container extra>
    <app-flex-grid
      :rows="[
        ['255px', '255px', '255px', '255px'],
        ['255px', '255px', '255px'],
        ['255px', '255px', '255px']
      ]"
    >
      <template #col-1-1>
        <app-form-group label="Education level" class="form-group--no-indent">
          <app-select
            v-model="documents.education_level"
            :options="edu_level_options"
            placeholder="Education level"
          />
        </app-form-group>
      </template>
      <template #col-1-2>
        <app-form-group label="Graduation date" class="form-group--no-indent">
          <app-date-picker
            v-model="documents.education_date_of_graduation"
            placeholder="Specify a date"
          />
        </app-form-group>
      </template>
      <template #col-1-3>
        <app-form-group label="Qualification" label-for="qualification" class="form-group--no-indent">
          <app-input
            id="qualification"
            v-model="documents.education_qualification"
            name="qualification"
            placeholder="Qualification"
          />
        </app-form-group>
      </template>
      <template #col-1-4>
        <app-form-group label="Diploma (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.education_diploma_scan_copy"
            :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
      <template #col-2-1>
        <app-form-group label="National ID" label-for="national_id" class="form-group--no-indent">
          <app-input
            id="national_id"
            v-model="documents.national_id"
            name="national_id"
            placeholder="National ID"
          />
        </app-form-group>
      </template>
      <template #col-2-2>
        <app-form-group label="National ID (Expire)" class="form-group--no-indent">
          <app-date-picker
            v-model="documents.national_id_expire"
            placeholder="Specify a date"
          />
        </app-form-group>
      </template>
      <template #col-2-3>
        <app-form-group label="National ID (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.national_id_scancopy"
            :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
      <template #col-3-1>
        <app-form-group label="Driver licence" label-for="driver_licence" class="form-group--no-indent">
          <app-input
            id="driver_licence"
            v-model="documents.driver_licence"
            name="driver_licence"
            placeholder="Driver licence"
          />
        </app-form-group>
      </template>
      <template #col-3-2>
        <app-form-group label="Driver licence (Expire)" class="form-group--no-indent">
          <app-date-picker
            v-model="documents.driver_licence_expire"
            placeholder="Specify a date"
          />
        </app-form-group>
      </template>
      <template #col-3-3>
        <app-form-group label="Driver licence (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.driver_licence_scancopy"
            :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
    </app-flex-grid>
    <app-flex-grid
      v-if="employee.position && ['driver', 'safari_driver'].includes(employee.position.code)"
      :rows="[['255px', '255px'], ['255px', '255px']]"
    >
      <template #col-1-1>
        <app-form-group
          label="Driving school certificate"
          label-for="driving_school_certificate"
          class="form-group--no-indent"
        >
          <app-input
            id="driving_school_certificate"
            v-model="documents.driving_school_certificate"
            name="driving_school_certificate"
            placeholder="Driving school certificate"
          />
        </app-form-group>
      </template>
      <template #col-1-2>
        <app-form-group label="Driving school certificate (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.driving_school_certificate_scancopy"
            :extensions="[
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/zip',
              'application/pdf',
              'image/jpeg',
              'image/png',
              'image/tiff',
              'image/bmp'
            ]"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
      <template #col-2-1>
        <app-form-group
          label="Driver Police Verification"
          label-for="Driver_police_verification"
          class="form-group--no-indent"
        >
          <app-input
            id="Driver_police_verification"
            v-model="documents.driver_police_verification"
            name="Driver_police_verification"
            placeholder="Driver Police Verification"
          />
        </app-form-group>
      </template>
      <template #col-2-2>
        <app-form-group label="Driver Police Verification (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.driver_police_verification_scancopy"
            :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
    </app-flex-grid>
    <app-flex-grid v-if="employee.position.code === 'safari_driver'" :rows="[['255px', '255px', '255px', '255px']]">
      <template #col-1-1>
        <app-form-group label="Safari Guiding license" label-for="safari_guiding_license" class="form-group--no-indent">
          <app-input
            id="safari_guiding_license"
            v-model="documents.safari_guiding_license"
            name="safari_guiding_license"
            placeholder="Safari Guiding license"
          />
        </app-form-group>
      </template>
      <template #col-1-2>
        <app-form-group label="Safari Guiding license code" class="form-group--no-indent">
          <app-input
            id="safari_guiding_license"
            v-model="documents.safari_guiding_license_code"
            name="safari_guiding_license"
            placeholder="Safari Guiding license"
          />
        </app-form-group>
      </template>
      <template #col-1-3>
        <app-form-group label="Safari guiding license (Expire)" class="form-group--no-indent">
          <app-date-picker
            v-model="documents.safari_guiding_license_expire"
            placeholder="Specify a date"
          />
        </app-form-group>
      </template>
      <template #col-1-4>
        <app-form-group label="Safari guiding license (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.safari_guiding_license_scancopy"
            :extensions="[
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/zip',
              'application/pdf',
              'image/jpeg',
              'image/png',
              'image/tiff',
              'image/bmp'
            ]"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
    </app-flex-grid>
    <app-flex-grid
      :rows="[
        ['255px'],
        ['255px', '255px'],
        ['255px', '255px'],
        ['255px', '255px', '255px', '255px']
      ]"
    >
      <template #col-1-1>
        <app-form-group label="Voting card" label-for="voting_card" class="form-group--no-indent">
          <app-input
            id="voting_card"
            v-model="documents.voting_card"
            name="voting_card"
            placeholder="Voting card"
          />
        </app-form-group>
      </template>
      <template #col-2-1>
        <app-form-group label="TIN" label-for="tin" class="form-group--no-indent">
          <app-input
            id="tin"
            v-model="documents.tin"
            name="tin"
            placeholder="TIN Number"
          />
        </app-form-group>
      </template>
      <template #col-2-2>
        <app-form-group label="TIN (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.tin_scancopy"
            :extensions="[
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/zip',
              'application/pdf',
              'image/jpeg',
              'image/png',
              'image/tiff',
              'image/bmp'
            ]"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
      <template #col-3-1>
        <app-form-group label="NSSF ID" label-for="nssf_id" class="form-group--no-indent">
          <app-input
            id="nssf_id"
            v-model="documents.nssf_id"
            name="nssf_id"
            placeholder="NSSF ID"
          />
        </app-form-group>
      </template>
      <template #col-3-2>
        <app-form-group label="NSSF ID (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.nssf_id_scancopy"
            :extensions="[
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/zip',
              'application/pdf',
              'image/jpeg',
              'image/png',
              'image/tiff',
              'image/bmp'
            ]"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
      <template #col-4-1>
        <app-form-group
          class="form-group--center form-group--no-indent form-group--switcher"
          label="The employee is an NHIF payer"
        >
          <app-switcher v-model="documents.nhif_payer"/>
        </app-form-group>
      </template>
      <template #col-4-2>
        <app-form-group v-if="!documents.nhif_payer" label="Family member (NHIF Payer)" class="form-group--no-indent">
          <app-select
            v-model="documents.nhif_payer_member"
            :display-field="option => option.full_name"
            :options="members_options"
            :searchable="false"
            label="full_name"
            placeholder="Member"
          />
        </app-form-group>
      </template>
      <template #col-4-3>
        <app-form-group label="NHIF ID" label-for="nhif_id" class="form-group--no-indent">
          <app-input
            id="nhif_id"
            v-model="documents.nhif_id"
            name="nhif_id"
            placeholder="NHIF ID"
          />
        </app-form-group>
      </template>
      <template #col-4-4>
        <app-form-group label="NHIF ID (Scan copy)" class="form-group--no-indent">
          <app-uploader
            v-model="documents.nhif_id_scancopy"
            :extensions="[
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/zip',
              'application/pdf',
              'image/jpeg',
              'image/png',
              'image/tiff',
              'image/bmp'
            ]"
            class="custom-uploader--flex"
            formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
          />
        </app-form-group>
      </template>
    </app-flex-grid>
    <app-cells :indent="false" position="end">
      <app-button ref="submit_documents" @click.native="onSendForm">
        Save
      </app-button>
    </app-cells>
  </app-page-container>
</template>

<script>

import { getEducationLevels, getEmployeesFamily, patchEmloyee } from '@/http'

export default {
  name: 'EmployeeDocuments',
  props: {
    employee: Object
  },
  data() {
    return {
      is_loaded: false,
      documents: { nhif_payer: false },
      edu_level_options: [],
      members_options: []
    }
  },
  watch: {
    employee: {
      handler(newVal) {
        this.documents = {
          national_id: newVal.national_id,
          national_id_expire: newVal.national_id_expire,
          national_id_scancopy: newVal.national_id_scancopy,
          driver_licence: newVal.driver_licence,
          driver_licence_expire: newVal.driver_licence_expire,
          driver_licence_scancopy: newVal.driver_licence_scancopy,
          voting_card: newVal.voting_card,
          fingerprint: newVal.fingerprint,
          tin: newVal.tin,
          tin_scancopy: newVal.tin_scancopy,
          nssf_id: newVal.nssf_id,
          nssf_id_scancopy: newVal.nssf_id_scancopy,
          nhif_id: newVal.nhif_id,
          nhif_id_scancopy: newVal.nhif_id_scancopy,
          driving_school_certificate: newVal.driving_school_certificate,
          driving_school_certificate_expire: newVal.driving_school_certificate_expire,
          driving_school_certificate_scancopy: newVal.driving_school_certificate_scancopy,
          driver_police_verification: newVal.driver_police_verification,
          driver_police_verification_expire: newVal.driver_police_verification_expire,
          driver_police_verification_scancopy: newVal.driver_police_verification_scancopy,
          safari_guiding_license: newVal.safari_guiding_license,
          safari_guiding_license_code: newVal.safari_guiding_license_code,
          safari_guiding_license_expire: newVal.safari_guiding_license_expire,
          safari_guiding_license_scancopy: newVal.safari_guiding_license_scancopy,
          education_level: newVal.education_level,
          education_date_of_graduation: newVal.education_date_of_graduation,
          education_qualification: newVal.education_qualification,
          education_diploma_scan_copy: newVal.education_diploma_scan_copy,
          nhif_payer: newVal.nhif_payer,
          nhif_payer_member: newVal.nhif_payer_member
        }
      },
      immediate: true
    }
  },
  created() {
    getEducationLevels().then(res => {
      this.edu_level_options = res.data
    })
    getEmployeesFamily(this.$route.params.id, { nhif: 'true' }).then(res => {
      this.members_options = res.data
    })
  },
  methods: {
    onSendForm() {
      this.$refs.submit_documents.preload = true
      patchEmloyee(this.$route.params.id, this.normalizeDocuments())
        .finally(() => {
          this.$refs.submit_documents.preload = false
        })
        .then(() => {
          this.$emit('update')
          this.$notify({
            type: 'success',
            title: 'Data saved successfully'
          })
        })
    },
    normalizeDocuments() {
      const normalizedForm = { ...this.documents }

      if (normalizedForm.education_level && typeof normalizedForm.education_level !== 'string') {
        normalizedForm.education_level = normalizedForm.education_level.code
      }
      if (normalizedForm.nhif_payer_member && typeof normalizedForm.nhif_payer_member !== 'number') {
        normalizedForm.nhif_payer_member = normalizedForm.nhif_payer_member.id
      }
      if (normalizedForm.education_diploma_scan_copy && normalizedForm.education_diploma_scan_copy.id) {
        normalizedForm.education_diploma_scan_copy = normalizedForm.education_diploma_scan_copy.id
      } else normalizedForm.education_diploma_scan_copy = null
      if (normalizedForm.national_id_scancopy && normalizedForm.national_id_scancopy.id) {
        normalizedForm.national_id_scancopy = normalizedForm.national_id_scancopy.id
      } else normalizedForm.national_id_scancopy = null
      if (normalizedForm.driver_licence_scancopy && normalizedForm.driver_licence_scancopy.id) {
        normalizedForm.driver_licence_scancopy = normalizedForm.driver_licence_scancopy.id
      } else normalizedForm.driver_licence_scancopy = null
      if (normalizedForm.tin_scancopy && normalizedForm.tin_scancopy.id) {
        normalizedForm.tin_scancopy = normalizedForm.tin_scancopy.id
      } else normalizedForm.tin_scancopy = null
      if (normalizedForm.nssf_id_scancopy && normalizedForm.nssf_id_scancopy.id) {
        normalizedForm.nssf_id_scancopy = normalizedForm.nssf_id_scancopy.id
      } else normalizedForm.nssf_id_scancopy = null
      if (normalizedForm.nhif_id_scancopy && normalizedForm.nhif_id_scancopy.id) {
        normalizedForm.nhif_id_scancopy = normalizedForm.nhif_id_scancopy.id
      } else normalizedForm.nhif_id_scancopy = null
      if (normalizedForm.driving_school_certificate_scancopy && normalizedForm.driving_school_certificate_scancopy.id) {
        normalizedForm.driving_school_certificate_scancopy = normalizedForm.driving_school_certificate_scancopy.id
      } else normalizedForm.driving_school_certificate_scancopy = null
      if (normalizedForm.driver_police_verification_scancopy && normalizedForm.driver_police_verification_scancopy.id) {
        normalizedForm.driver_police_verification_scancopy = normalizedForm.driver_police_verification_scancopy.id
      } else normalizedForm.driver_police_verification_scancopy = null
      if (normalizedForm.safari_guiding_license_scancopy && normalizedForm.safari_guiding_license_scancopy.id) {
        normalizedForm.safari_guiding_license_scancopy = normalizedForm.safari_guiding_license_scancopy.id
      } else normalizedForm.safari_guiding_license_scancopy = null

      return normalizedForm
    }
  }
}
</script>
<style lang="sass" scoped>
.employee__wrapper
  max-width: 1180px
</style>
